module.exports = __webpack_public_path__ + "img/icon_chengyuxiaoshou.0c1d9526.png";